import { http, createConfig } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { walletConnect, injected } from 'wagmi/connectors';

// WalletConnect Project ID
const projectId = '118842be6f66558c9a166255a553366f';

// Configure chains & providers
export const config = createConfig({
  chains: [bsc],
  connectors: [
    walletConnect({
      projectId,
      metadata: {
        name: 'Little Rabbit',
        description: 'Little Rabbit Staking Token DApp',
        url: 'https://littlerabbit.com',
        icons: ['https://avatars.githubusercontent.com/u/37784886']
      },
      showQrModal: false
    }),
    // Injected connector supports MetaMask, Trust Wallet, SafePal and other browser wallets
    injected({
      shimDisconnect: true,
      target() {
        return {
          id: 'injected',
          name: 'Browser Wallet',
          provider: typeof window !== 'undefined' ? window.ethereum : undefined
        };
      }
    })
  ],
  transports: {
    [bsc.id]: http('https://bsc-dataseed1.bnbchain.org')
  }
});

export { projectId };
